import axios from "axios";
import {
    SUBADMIN_LIST, GET_PERMISSIONS, PERMISSION_FAIL, ALL_MEDIA_LIST, FAIL_PERMISSIONS_FLAG, GET_PERMISSIONS_FLAG, GET_TP_LEADS, GET_TP_LEADS_LOADING, GET_TP_LEADS_ERROR
} from "../type/type";

const PROXY = process.env.REACT_APP_API_URL + "api/";

export const getSubAdminList = (page, limit, search) => async (dispatch) => {
    const res = await axios.get(
        PROXY + "sub-admin?page=" + page + "&limit=" + limit + "&search=" + search
    );
    dispatch({
        type: SUBADMIN_LIST,
        payload: res.data.result,
    });
};

export const addNewSubAdmin = (subAdminData) => async (dispatch) => {
    return await axios.post(PROXY + "sub-admin/add", subAdminData);
};

export const deleteSubAdmin = (id) => async (dispatch) => {
    const res = await axios.delete(PROXY + "sub-admin/" + id);
    return res;
};

export const getSubAdminDetailsById = (id) => async (dispatch) => {
    const res = await axios.get(PROXY + "sub-admin/get/" + id);
    return res;
};

export const updateSubAdmin = (id, subAdminData) => async (dispatch) => {
    const res = await axios.put(PROXY + 'sub-admin/' + id, subAdminData)
    return res
}

export const getPermission = () => async (dispatch, getState) => {

    try {
        const res = await axios.get(PROXY + 'sub-admin/permissions');
        const { user } = getState().auth;
        dispatch({
            type: GET_PERMISSIONS,
            payload: {
                permissions: res.data.permissions,
                userType: user?.type || '',
            },
        });
        return res;
    } catch (error) {
        dispatch({ type: PERMISSION_FAIL });
        return Promise.reject(error);
    }
};

export const getSubadminPermissionFlags = () => async (dispatch) => {

    try {
        const res = await axios.get(PROXY + 'sub-admin/permissionFlags');
        dispatch({
            type: GET_PERMISSIONS_FLAG,
            payload: res.data.result
        });
        return res;
    } catch (error) {
        dispatch({ type: FAIL_PERMISSIONS_FLAG });
        return Promise.reject(error);
    }

};

export const uploadMedia = (data) => async (dispatch) => {
    return await axios.post(PROXY + "sub-admin/upload-media", data);
};

export const getAllMedia = (page, limit, search) => async (dispatch) => {
    const res = await axios.get(
        PROXY + "sub-admin/list-media?page=" + page + "&limit=" + limit + "&search=" + search
    );
    dispatch({
        type: ALL_MEDIA_LIST,
        payload: res.data.result,
    });
};

export const deleteMedia = (id) => async (dispatch) => {
    const res = await axios.delete(PROXY + "sub-admin/media/" + id);
    return res;
};

// TP Leads
export const getAllLeads = (obj) => async (dispatch) => {
    try {
        dispatch({ type: GET_TP_LEADS_LOADING });

        const params = {
            ...obj,
            admin: JSON.stringify(obj.admin)
        };

        const res = await axios.get(PROXY + 'leads/all', { params });
        
        dispatch({
            type: GET_TP_LEADS,
            payload: res.data.result,
        });

        // return res;
    }
    catch (err) {
        dispatch({ type: GET_TP_LEADS_ERROR });
        return err
    }
};

export const createCombination = (obj) => async () => {
    const res = await axios.post(PROXY + 'olaleads/add-tp-leads', obj);
    return res;
};